import { render, staticRenderFns } from "./BudgetIssuesMissingClientsComponent.vue?vue&type=template&id=7b2ee4fe&scoped=true"
import script from "./BudgetIssuesMissingClientsComponent.vue?vue&type=script&lang=js"
export * from "./BudgetIssuesMissingClientsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2ee4fe",
  null
  
)

export default component.exports